import envConfig from 'configs/envConfig';
import { TPartnerAssets } from 'partners/types';
import { storedLocale } from 'partners/storedLocale';
import HaloviewLogoMark from 'assets/haloview/logoMark.svg?react';

const haloviewBaseUrl = `${envConfig('b2BucketUrl')}/homeSecurity/haloview`;

export const defaultAssets: TPartnerAssets = {
  logo: `${haloviewBaseUrl}/logo.svg`,
  loginIllustration: `${haloviewBaseUrl}/loginIllustration.svg`,
  Days30EventIcon: `${haloviewBaseUrl}/30DaysEventIcon.svg`,
  CannotAddSelectedCameraIcon: `${haloviewBaseUrl}/CannotAddSelectedCamera.svg`,
  attentionIcon: `${haloviewBaseUrl}/attention.svg`,
  basicAlertsIcon: `${haloviewBaseUrl}/basicAlertsIcon.svg`,
  basicMotionAlertsImg: `${haloviewBaseUrl}/basicMotionAlerts.png`,
  clockIcon: `${haloviewBaseUrl}/clockIcon.svg`,
  decriptiveAIAlertsIcon: `${haloviewBaseUrl}/decriptiveAIAlertsIcon.svg`,
  firmwareVersionIcon: `${haloviewBaseUrl}/firmwareVersionIcon.svg`,
  interntNotConnectedIcon: `${haloviewBaseUrl}/interntNotConnected.svg`,
  limitedSecurityIcon: `${haloviewBaseUrl}/limitedSecurityIcon.png`,
  locationIcon: `${haloviewBaseUrl}/location.svg`,
  logoContrastIcon: `${haloviewBaseUrl}/logoContrast.svg`,
  logoWhiteIcon: `${haloviewBaseUrl}/logoWhite.svg`,
  logoMarkIcon: HaloviewLogoMark,
  maxCameraLimitReachedIcon: `${haloviewBaseUrl}/maxCameraLimitReached.svg`,
  AllCamerasAddedToAccountIcon: `${haloviewBaseUrl}/AllCamerasAddedToAccount.svg`,
  noEventVideosIcon: `${haloviewBaseUrl}/noEventVideosIcon.svg`,
  paymentFailedIcon: `${haloviewBaseUrl}/paymentFailedIcon.svg`,
  DownGradeConfirmationIcon: `${haloviewBaseUrl}/DownGradeConfirmation.svg`,
  paymentSuccessfulIcon: `${haloviewBaseUrl}/PaymentSuccessful.svg`,
  planLevelOneIcon: `${haloviewBaseUrl}/planLevelOneIcon.svg`,
  planLevelThreeIcon: `${haloviewBaseUrl}/planLevelThreeIcon.svg`,
  planLevelTwoIcon: `${haloviewBaseUrl}/planLevelTwoIcon.svg`,
  professionMonitoringIcon: `${haloviewBaseUrl}/professionMonitoringIcons.svg`,
  sampleCreditCardIcon: `${haloviewBaseUrl}/sampleCreditCard.svg`,
  FreeTrialActivatedIcon: `${haloviewBaseUrl}/FreeTrialActivated.svg`,
  upgradeSnapshotIcon: `${haloviewBaseUrl}/upgradeSnapshot.svg`,
  wifiIcon: `${haloviewBaseUrl}/wifiIcon.svg`,
  appQRCodeAndroid: `${haloviewBaseUrl}/qrCodeAndroid.png`,
  appQRCodeIos: `${haloviewBaseUrl}/qrCodeIos.png`,
  motionAlertsIcon: `${haloviewBaseUrl}/motionAlerts.png`,
  snapshotIcon: `${haloviewBaseUrl}/snapshotIcon.png`,
  liveViewIcon: `${haloviewBaseUrl}/liveViewIcon.png`,
  dataIcon: `${haloviewBaseUrl}/dataIcon.png`,
  noDataIcon: `${haloviewBaseUrl}/noDataIcon.png`,
  autoDataRechargeDisabled: `${haloviewBaseUrl}/autoDataRechargeDisabled.png`,
};

// 2️⃣ Locale-specific overrides
const localeOverrides: Record<string, Partial<TPartnerAssets>> = {
  es: {
    basicMotionAlertsImg: `${haloviewBaseUrl}/basicMotionAlerts-es.png`,
  }
};

// 3️⃣ Merge default with overrides
export const getAssetsForLocale = (locale: string): TPartnerAssets => {
  return {
    ...defaultAssets,
    ...localeOverrides[locale]
  };
};

const locale = storedLocale();

export const assets = getAssetsForLocale(locale || 'en-US');
